import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFilter = () => {
  return (
    <g>
      <path d="m15.83 1.2461a.75.75 0 0 0 -.689-.4541h-14.2821a.75.75 0 0 0 -.544 1.2666l5.5933 5.8887v6.5107a.75.75 0 0 0 1.5 0v-6.8105a.7506.7506 0 0 0 -.206-.5166l-4.5967-4.8389h10.789l-4.5967 4.8389a.7506.7506 0 0 0 -.206.5166v5.2334a.75.75 0 1 0 1.5 0v-4.9336l5.5933-5.8887a.75.75 0 0 0 .1449-.8125z" />
    </g>
  );
};

export default withIcon(IconFilter);
